customElements.define(
  'menu-drawer-toggle',
  class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', () => {
        document.body.classList.toggle('menu-drawer-open');
        document.body.classList.toggle('overflow-hidden');
      });
    }
  }
);

customElements.define(
  'toggle-search',
  class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', () => {
        document.body.classList.toggle('header-search-is-open');
        document.body.classList.toggle('overflow-hidden');

        const searchInput = document.querySelector('[data-search-input]');
        if (document.body.classList.contains('header-search-is-open') && searchInput) {
          searchInput.focus();
        }
      });
    }
  }
);

customElements.define(
  'parent-link',
  class extends HTMLElement {
    connectedCallback() {
      const backButton = document.querySelectorAll('[data-menu-drawer-back]');
      this.addEventListener('click', () => {
        this.classList.toggle('active');
        document.body.classList.toggle('submenu-open');
      });
      backButton.forEach((el) =>
        el.addEventListener('click', () => this.classList.remove('active'))
      );
    }
  }
);

customElements.define(
  'search-form',
  class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('submit', () => {
        // check if the search form is not empty before submitting
        const searchInput = this.querySelector('input[name="q"] ');
        if (searchInput.value.trim() === '') {
          return;
        }

        this.submit();
      });
    }
  }
);
